import api from "./api.js";

export default class NoticeApi {
  static async getList(data) {
    return await api.get(`api/notice`, data);
  }

  static async getDetail(id) {
    return await api.get(`api/notice/${id}`);
  }
}
